import { useContext } from 'react'

import DataCollectedModalContext from 'contexts/DataCollectedModalContext'

const useDataCollected = () => {
  const context = useContext(DataCollectedModalContext)

  if (context === undefined) {
    throw new Error(
      'useDataCollected must be used within a DataCollectedModalContext.Provider',
    )
  }

  return {
    data: context.data,
    loadData: context.loadData,
    setData: context.setData,
    isLoading: context.isLoading,
  }
}

export default useDataCollected
